import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HomeCard from './HomeCard/HomeCard';
import IncreaseReport from '../shared/Modal/ModalContent/IncreaseReport/IncreaseReport';
import { getTranslation } from '../../utils/translation';
import { roundNumber } from '../../utils/formatDecimal';
import {
    changeIncreaseCreditModalProps,
    changeIncreaseReportModalProps,
} from '../../store/actions/modals';
import styles from './Home.module.scss';
import Modal from '../shared/Modal/Modal';
import { Link } from 'react-router-dom';
import { printCashierBalance } from '../../store/actions/reports';
import { getUserAccount } from '../../store/actions/user';
import moment from 'moment';
import { increaseDebt } from '../../store/actions/increase-reports';
import IncreaseCredit from '../shared/Modal/ModalContent/IncreaseCredit/IncreaseCredit';

function HomePage() {
    const dispatch = useDispatch();
    const cashierInfo = useSelector(state => state.settings.account.data);
    const modalProps = useSelector(state => state.modals.increaseReportModal);
    const increaseCreditModalProps = useSelector(state => state.modals.increaseCreditModal);

    const [isBalanceHovered, setIsBalanceHovered] = useState(false);

    const onIncreaseCreditClick = () => {
        dispatch(
            changeIncreaseCreditModalProps({
                isVisible: true,
                confirmation: { message: getTranslation('increaseReportSuccessModalTitle') },
            })
        );
    };

    const cards = [
        {
            disabled: false,
            title: getTranslation('menu.sports'),
            actionElement: (
                <Link className={`${styles.menuAction} ${styles.linkAction}`} to={'/app/sports'}>
                    {getTranslation('menu.actions.playNow')}
                </Link>
            ),
            iconName: 'sports',
            isLink: true,
        },
        {
            disabled: false,
            title: getTranslation('menu.live'),
            actionElement: (
                <Link className={`${styles.menuAction} ${styles.linkAction}`} to={'/app/live'}>
                    {getTranslation('menu.actions.playNow')}
                </Link>
            ),
            iconName: 'live',
            isLink: true,
        },
        {
            disabled: false,
            title: getTranslation('menu.results'),
            actionElement: (
                <Link className={`${styles.menuAction} ${styles.linkAction}`} to={'/app/results'}>
                    {getTranslation('menu.actions.look')}
                </Link>
            ),
            iconName: 'results',
            isLink: true,
        },
        {
            disabled: false,
            title: getTranslation('common.remainingLimit'),
            actionElement: (
                <Link
                    className={`${styles.menuAction} ${
                        isBalanceHovered ? styles.currentBalanceAction : ''
                    }`}
                    to={'#'}
                    onMouseEnter={() => setIsBalanceHovered(true)}
                    onMouseLeave={() => setIsBalanceHovered(false)}
                    onClick={async () => {
                        const userData = await dispatch(getUserAccount());
                        printCashierBalance({
                            issueDate: moment().format('DD/MM/YYYY HH:mm:ss'),
                            cashierCode: userData.accountNumber,
                            balance: `${userData.currentLimit.toLocaleString('en')} AZN`,
                        });
                    }}
                >
                    {isBalanceHovered
                        ? getTranslation('print')
                        : `${
                              cashierInfo ? roundNumber(cashierInfo.currentLimit, 2) + ' AZN' : ''
                          } `}
                </Link>
            ),
            iconName: 'remainingLimit',
            isLink: false,
        },
        {
            disabled: false,
            title: getTranslation('menu.printProgram'),
            actionElement: (
                <Link
                    className={`${styles.menuAction} ${styles.linkAction}`}
                    to={'/app/point/sportsbook'}
                >
                    {getTranslation('menu.actions.printNow')}
                </Link>
            ),
            iconName: 'printer',
            isLink: true,
        },
        {
            disabled: false,
            title: getTranslation('menu.dailyReport'),
            actionElement: (
                <Link
                    className={`${styles.menuAction} ${styles.linkAction}`}
                    to={'/app/point/reports'}
                >
                    {getTranslation('menu.actions.look')}
                </Link>
            ),
            iconName: 'report',
            isLink: true,
        },
        {
            disabled: false,
            title: getTranslation('menu.balanceReport'),
            actionElement: (
                <Link
                    className={`${styles.menuAction} ${styles.linkAction}`}
                    to={'/app/point/balance'}
                >
                    {getTranslation('menu.actions.look')}
                </Link>
            ),
            iconName: 'report',
            isLink: true,
        },
        {
            disabled: false,
            title: getTranslation('menu.point.creditLimit'),
            actionElement: (
                <div className={styles.increaseReportActions}>
                    <Link
                        className={`${styles.menuAction} ${styles.linkAction}`}
                        to={'#'}
                        onClick={() => {
                            dispatch(changeIncreaseReportModalProps({ isVisible: true }));
                        }}
                    >
                        {getTranslation('menu.actions.increase')}
                    </Link>
                    <Link
                        className={`${styles.menuAction} ${styles.linkAction}`}
                        to={'#'}
                        onClick={onIncreaseCreditClick}
                    >
                        {getTranslation('menu.actions.creditBalance')}
                    </Link>
                </div>
            ),
            iconName: 'credit',
            isLink: true,
        },
    ];

    return (
        <div className={styles.homeWrapper}>
            <div className={styles.homeContainer}>
                {cards.map((card, _index) => (
                    <HomeCard key={_index} {...card} />
                ))}
                {modalProps.isVisible && (
                    <Modal
                        isVisible={modalProps.isVisible}
                        width='476px'
                        textAlign='center'
                        contentPadding='50px 0'
                    >
                        <IncreaseReport />
                    </Modal>
                )}
                {increaseCreditModalProps.isVisible && (
                    <Modal
                        isVisible={increaseCreditModalProps.isVisible}
                        width='476px'
                        textAlign='center'
                        contentPadding='50px 0'
                    >
                        <IncreaseCredit />
                    </Modal>
                )}
            </div>
        </div>
    );
}

export default HomePage;
